import { CameraAlt } from '@mui/icons-material';
import { Box, IconButton, TextField, Typography } from '@mui/material';
import React from 'react';
import SignUpOnboardingStep from './SignUpOnboardingStep';
import PhoneInput from 'react-phone-number-input';
import { isEmpty } from 'lodash';
import Logo from '../../images/logo.png';
import useStore from '../../Store/Store';
import { useQuery } from 'react-query';
import { getUserInfo } from '../../utils/api';
import moment from 'moment';
import api from '../../utils/api/apiRequestConfig';
import { careUserType } from '../../constants';
import Button from '../../components/Button';
import { useUserLocation } from '../../hooks/useUserLocation';

const UserForm = ({ handleBackStep, handleNextStep, email, errorMessage, loader, userType }) => {
  const uploadRef = React.useRef();
  const width = useStore((state) => state.screenWidth);
  const { country } = useUserLocation();

  const [state, setState] = React.useState({
    firstName: '',
    lastName: '',
    dob: '',
    phoneNo: '',
    image: null,
    imageToDisplay: null,
  });

  const {
    data: userData,
    isLoading,
    refetch,
  } = useQuery(['getUserInfo'], () => getUserInfo({ userId: null }), {
    retry: false,
    cacheTime: 0,
  });

  React.useEffect(() => {
    if (!isEmpty(userData)) {
      const { data } = userData;
      setState((prev) => {
        return {
          ...prev,
          firstName: data?.userInfo?.firstName || '',
          lastName: data?.userInfo?.lastName || '',
          dob: !isEmpty(data?.userInfo?.birthdate) ? moment(data?.userInfo?.birthdate).format('YYYY-MM-DD') : '',
          phoneNo: data?.username || '',
          imageToDisplay: data?.userInfo?.imageUrl,
        };
      });
    }
  }, [userData]);

  const handleOpenImageUpload = () => {
    uploadRef.current.click();
  };

  const handleSetImage = async (e) => {
    try {
      const image = e.target.files[0];

      const response = await api.get(
        `${process.env.REACT_APP_EXPRESS_URL}/api/users/${sessionStorage.getItem('userId')}/getSignedImageURL`,
        {
          headers: {
            'Content-Type': 'application/json',
            authorization: sessionStorage.getItem('token'),
            'ngrok-skip-browser-warning': 'true',
          },
        },
      );

      if (response.status !== 200) {
        throw new Error('Incorrect email or password');
      }

      const postURL = response?.data?.data?.postURL;

      await api.put(postURL, image, {
        headers: {
          'Content-Type': 'image/jpeg',
        },
      });

      setState((prev) => {
        return { ...prev, image: postURL.split('?')[0], imageToDisplay: URL.createObjectURL(image) };
      });
    } catch (error) {
      console.error('Error uploading image:', error);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: width > 1050 ? '50%' : '100%',
        padding: '1rem',
      }}
    >
      <Box
        component="img"
        sx={{ width: '55px', height: '37.56px', marginBottom: '2rem' }}
        alt="Mask group"
        src={Logo}
      />
      <div style={{ paddingInline: '4rem', paddingBlock: '5rem' }}>
        <SignUpOnboardingStep
          total={userType === careUserType.professional_caregiver ? 2 : userType === careUserType.careRecipient ? 4 : 3}
          step={2}
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Typography variant="h4" sx={{ fontWeight: 'medium', color: 'rgba(29, 29, 31, 1)' }}>
            Create your account
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
            {isEmpty(state.imageToDisplay) ? (
              <IconButton
                sx={{ width: 70, height: 70, backgroundColor: 'rgba(245, 245, 247, 1)', borderRadius: '100px' }}
              >
                <CameraAlt />
              </IconButton>
            ) : (
              <img src={state.imageToDisplay} alt="image" style={{ width: 70, height: 70, borderRadius: '50%' }} />
            )}
            <input type="file" style={{ display: 'none' }} onChange={handleSetImage} ref={uploadRef} />

            <Button text="Upload photo" bg="light" onClick={handleOpenImageUpload} />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <TextField
              label="First name*"
              placeholder="Linda"
              variant="outlined"
              fullWidth
              InputProps={{ style: { borderRadius: '100px' } }}
              onChange={(e) =>
                setState((prev) => {
                  return {
                    ...prev,
                    firstName: e.target.value,
                  };
                })
              }
              value={state.firstName}
            />
            <TextField
              label="Last name*"
              placeholder="Wilson"
              variant="outlined"
              fullWidth
              InputProps={{ style: { borderRadius: '100px' } }}
              onChange={(e) =>
                setState((prev) => {
                  return {
                    ...prev,
                    lastName: e.target.value,
                  };
                })
              }
              value={state.lastName}
            />
            <TextField
              type="date"
              placeholder="MM/DD/YYYY"
              variant="outlined"
              fullWidth
              InputProps={{
                style: { borderRadius: '100px' },
              }}
              onChange={(e) =>
                setState((prev) => {
                  return {
                    ...prev,
                    dob: e.target.value,
                  };
                })
              }
              value={state.dob}
            />
            <TextField
              placeholder="l-wilson@gmail.com"
              variant="outlined"
              fullWidth
              InputProps={{ style: { borderRadius: '100px' } }}
              value={email || sessionStorage.getItem('email')}
              disabled={true}
            />
            <Box sx={{ display: 'flex', gap: 1 }}>
              <PhoneInput
                placeholder="Enter phone number"
                defaultCountry={country}
                // flagUrl="https://flag.pk/flags/4x3/{xx}.svg"
                addInternationalOption={true}
                limitMaxLength={true}
                style={{
                  border: '1px solid #C2C8D6',
                  boxSizing: 'border-box',
                  height: '57px',
                  paddingLeft: '20px',
                  marginTop: '8px',
                  borderRadius: '100px',
                  width: '100%',
                }}
                value={state.phoneNo}
                numberInputProps={{
                  className: 'input-child input-child-2',
                }}
                onChange={(value) =>
                  setState((prev) => {
                    return {
                      ...prev,
                      phoneNo: value,
                    };
                  })
                }
              />
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 6, marginTop: '40px' }}>
          <Button text="Back" bg="light" onClick={handleBackStep} fullWidth />
          <Button text="Next" onClick={() => handleNextStep(state)} loading={loader} fullWidth />
        </Box>
      </div>
      <Typography variant="subtitle1" style={{ color: 'red', marginTop: '-30px' }} textAlign="center">
        {errorMessage}
      </Typography>
    </Box>
  );
};
export default UserForm;
